import errorHandler from "../helpers/errorHandler";
import render from '../helpers/renderRouterView'

export default [
  {
    path: 'shop/',
    component: {
      render
    },
    children: [
      {
        path: '',
        name: 'TheShopList',
        component: () => import('../views/TheShop/TheShopList').catch(errorHandler),
        meta: {
          authorization: false,
          title: 'Магазин',
        },
      },
      {
        path: 'my',
        name: 'TheMyShop',
        component: () => import('../views/TheShop/TheMyShop').catch(errorHandler),
        meta: {
          authorization: false,
          title: 'Магазин',
        },
      },
      {
        path: 'favourite',
        name: 'TheFavouriteShop',
        component: () => import('../views/TheShop/TheFavouriteShop').catch(errorHandler),
        meta: {
          authorization: false,
          title: 'Магазин',
        },
      },
    ],
  },
  {
    path: 'shop/:id',
    name: 'TheShopDetail',
    component: () => import('../views/TheShop/TheShopDetail').catch(errorHandler),
    meta: {
      authorization: false,
      title: 'Магазин',
    },
  },
]
